import { createFileRoute } from "@tanstack/react-router";
import { priceGuideRoute } from "@/lib/seo/priceGuideRoute";
import { getPriceGuide } from "@/lib/seo/priceGuides";

export const Route = createFileRoute("/pris_/filmabonnemang")(
  priceGuideRoute(getPriceGuide("filmabonnemang")),
);
